import { Component } from '@angular/core';
import { AlertController, ModalController } from 'ionic-angular';

import { NutritionModel, FoodPlanModel, UserModel } from '../../models/models';
import { ConfigurationProvider, FoodPlanProvider, UserProvider } from '../../providers/providers';
import { FoodPlanEditPage } from './food-plan-edit';

@Component({
  selector: 'page-food-plan',
  templateUrl: 'food-plan.html',
})
export class FoodPlanPage {
  nutritionTarget?: NutritionModel;

  foodPlanList: any = [];
  isLoaded: boolean = false;
  page: string = 'food-plans';
  user: UserModel;

  constructor(
    private alertCtrl: AlertController,
    private config: ConfigurationProvider,
    private foodPlanProvider: FoodPlanProvider,
    private modalCtrl: ModalController,
    private userProvider: UserProvider) {
  }

  doEditFoodPlan(foodPlan: FoodPlanModel = new FoodPlanModel()) {
    let modal = this.modalCtrl.create(FoodPlanEditPage, { 
      foodPlan: foodPlan,
      user: this.user
    });
    modal.present();

    modal.onDidDismiss(data => {
      if (data && data.saved) {
        this.config.showToast('"' + data.name + '" saved!');
        this.loadFoodPlans();
      }
    });
  }

  doRemove(item: FoodPlanModel) {
    let confirm = this.alertCtrl.create({
      title: `Remove ${item.Name}?`,
      message: 'Are you sure?',
      buttons: [
        {
          text: 'Cancel',
        },
        {
          text: 'Remove',
          handler: () => {
            this.config.showLoading('Removing...');
            this.foodPlanProvider.Remove(item).then((items) => {
              this.foodPlanList = items;
              this.config.showToast(item.Name + ' removed!');
              this.config.dismissLoading();
            });
          }
        }
      ]
    });
    confirm.present();
  }

  ionViewDidLoad() {
    this.loadView();
  }

  loadFoodPlans() {
    this.config.showLoading();
    this.isLoaded = false;
    this.foodPlanProvider.Load(this.user._id, true).then((items: FoodPlanModel[]) => {
      for (let item of items as any[]) {
        item.icon = 'arrow-dropdown';
        item.showDetails = false;
      }
      this.foodPlanList = items;
      this.loadNutritionTargets();
      this.isLoaded = true;
      this.config.dismissLoading();
    });
  }

  loadNutritionTargets() {
    this.nutritionTarget = this.config.getNutritionTarget(this.user.BodyWeight, this.user.BodyHeight, this.user.Age);
    this.foodPlanList.map(foodPlan => {
      foodPlan.TargetPercentage = this.config.getNutritionTargetPercent(foodPlan.Nutrition, this.nutritionTarget);
    });
  }

  loadView() {
    this.user = this.userProvider.Get();
    this.foodPlanList = this.foodPlanProvider.List();
    if (this.foodPlanList.length === 0) {
      this.loadFoodPlans();
    }
    else {
      this.loadNutritionTargets();
      this.isLoaded = true;
    }
  }

  toggleDetails(item) {
    if (item.Nutrition.Calories > 0) {
      const showDetails = (item) => {
        if (item.showDetails) {
          item.showDetails = false;
          item.icon = 'arrow-dropdown';
        }
        else {
          item.showDetails = true;
          item.icon = 'arrow-dropup';
        }
      };

      if (item.FoodItems) {
        showDetails(item);
      }
      else {
        this.config.showLoading();
        this.foodPlanProvider.LoadFoodItems(item).then((foodPlan) => {
          item = foodPlan;
          showDetails(item);
          this.config.dismissLoading();
        });
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/food/food-plan.ts